<template>
  <section>
    <banner-list :query="query" />
  </section>
</template>

<script>
import BannerList from '@/components/home/BannerList'

export default {
  name: 'HomeBanners',
  components: {
    BannerList
  },

  data() {
    const { query } = this.$route

    return {
      query: query
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === from.name) {
      this.query = to.query
    }

    next()
  }
}
</script>
